import { render } from "./BarChartComponent.vue?vue&type=template&id=421ea20e&scoped=true"
import script from "./BarChartComponent.vue?vue&type=script&lang=js"
export * from "./BarChartComponent.vue?vue&type=script&lang=js"

import "./BarChartComponent.vue?vue&type=style&index=0&id=421ea20e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-421ea20e"

export default script